import angular from 'angular';

class DetaljiPacijentaController {
    constructor($stateParams){
        this.pacijent = $stateParams.id;
    }

}

DetaljiPacijentaController.$inject=['$stateParams'];

export {DetaljiPacijentaController};



// WEBPACK FOOTER //
// ./app/components/pacijent/detalji.pacijenta.controller.js